<template>
    <g-bottom-drawer
        :visible="$root.showShopDrawer"
        :height="tiebaInfo.third_store_info.is_show_tieba_layer === 1 ?
            $root.isShowFourElements === 1 ? 1331 : 1241 : 870"
        @coverClick="closeDrawer"
    >
        <div class="download-shop-drawer">
            <div class="download-info" :style="{backgroundImage: 'url(' + shopDrawerBg + ')'}">
                <div class="download-info-head">
                    <div class="download-info-head-left">
                        <img :src="downloadShopIcon" class="downloadShopIcon">
                        <div class="download-info-head-title">
                            由第三方应用商店提供安装服务（来自{{ appDetail.third_app_store_name }}）
                        </div>
                    </div>
                    <img
                        :src="downloadShopCloseIcon" class="downloadShopCloseIcon"
                        @click.stop="closeDrawer"
                    >
                </div>
                <div class="download-info-center">
                    <div class="download-info-left">
                        <img :src="appDetail.icon" class="game-icon">
                        <div class="game-info">
                            <div class="game-name">{{ appDetail.appName }}</div>
                            <div class="game-info-download">
                                <div class="game-size">{{ appDetail.capacity }}</div>
                                <div class="split-line"></div>
                                <div class="game-download-num">{{ appDetail.downloadNum }}次安装</div>
                            </div>
                        </div>
                    </div>
                    <div class="download-btn">
                        <download-btn
                            v-if="thePackage.download_url && thePackage.package_name && appDetail.appId"
                            :download-url="thePackage.download_url"
                            :package-name="thePackage.package_name"
                            :app-id="appDetail.appId"
                            :game-name="appDetail.appName"
                            :is-shop-btn="true"
                            :shop-download-flag="shopDownloadFlag"
                            :btn-color="'#3388FF'"
                        />
                    </div>
                </div>
                <div class="download-info-game-desc">
                    {{ appDetail.desc }}
                </div>
            </div>
            <div class="tieba-content">
                <div class="tieba-title">{{ tiebaInfo.third_store_info.store_title }}</div>
                <div class="tieba-container">
                    <tieba-float-panel
                        v-if="tiebaInfo.third_store_info.is_show_tieba_layer === 1"
                        :tieba-info="tiebaInfo"
                        :app-detail="appDetail"
                        :is-shop-drawer="true"
                    />
                    <div
                        class="tieba-btn"
                        :style="{'margin-top': $root.isShowFourElements === 1 ? '' : '2.6vh'}"
                        @click="goTiebaPage"
                    >
                        <div class="tieba-btn-text">进入社区</div>
                    </div>
                </div>
            </div>
        </div>
    </g-bottom-drawer>
</template>

<script>
import {getQueryString} from '@/utils/url';
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import {isIOS, copy, browserDetect} from '@/utils/browser';
import {generateToken} from '@/utils/tiebaUtility';
import GBottomDrawer from '@/composition-components/GBottomDrawer.vue';
import downloadShopIcon from 'public/assets/imgs/download-shop-icon.png';
import downloadShopCloseIcon from 'public/assets/imgs/download-shop-close-icon.png';
import shopDrawerBg from 'public/assets/imgs/download-shop-drawer-bg.png';
import TiebaFloatPanel from '../tieba/tieba-float-panel.vue';
import DownloadBtn from '@/pages/topList/components/download-btn.vue';
export default {
    components: {
        GBottomDrawer,
        TiebaFloatPanel,
        DownloadBtn,
    },
    props: {
        tiebaInfo: {
            type: Object,
            default: () => {},
        },
        appDetail: {
            type: Object,
            required: true,
        },
        appId: {
            type: String,
            default: '',
        },
    },
    computed: {
        thePackage() {
            return (this.appDetail.package_list && this.appDetail.package_list[0]) || {};
        },
        showDrawer() {
            return this.$root.showShopDrawer;
        },
    },
    data() {
        return {
            downloadStatus: 0,
            process: 0,
            showShopDrawer: false,
            downloadShopIcon: downloadShopIcon,
            downloadShopCloseIcon: downloadShopCloseIcon,
            isIOS: isIOS,
            shopDrawerBg: shopDrawerBg,
            shopDownloadFlag: false,
        };
    },
    watch: {
        showDrawer(val) {
            if (val) {
                this.$root.sendLog('display', 'DownloadlayerDisplay');
                const inBdBoxapp = browserDetect('bdbox');
                if (inBdBoxapp || (!inBdBoxapp && getQueryString('isDownload') === '2')) {
                    this.shopDownloadFlag = !this.shopDownloadFlag;
                }
            }
        },
    },
    methods: {
        closeDrawer() {
            this.$root.showShopDrawer = false;
            this.$root.sendLog('click', 'CloseBtnClick');
        },
        getToken() {
            const config = {
                page: 'frs',
                param: {
                    kw: this.appDetail.join_community_info?.forum_name || '',
                    fid: this.appDetail.join_community_info?.forum_id || '',
                    extdata: {},
                    track: '',
                    locate: 'gamecenter',
                },
            };
            return generateToken(config);
        },
        goTiebaPage() {
            this.$root.sendLog('click', 'CommunityClick');
            const token = this.getToken();
            copy(token);
            this.$root.report(token).then(() => {
                TiebaNewWakeUp.init({
                    page: 'frs',
                    param: {
                        obj_source: 'wise',
                        kw: this.appDetail.join_community_info?.forum_name || '',
                        fid: this.appDetail.join_community_info?.forum_id || '',
                        locate: 'outer_game_joinsq',
                    },
                    androidShoubaiGoCenterPage: false,
                    androidDownUrl: this.tiebaInfo.third_store_info?.join_url || '',
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.download-shop-drawer {
    width: 1242px;
    .download-info {
        margin-bottom: 77px;
        background-size: 100% auto;
        padding: 51px 51px 0 51px;
        box-sizing: border-box;
        .download-info-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 51px;
            .download-info-head-left {
                display: flex;
                align-items: center;
                .downloadShopIcon {
                    width: 42px;
                    height: 42px;
                    margin-right: 12px;
                }
                .download-info-head-title {
                    opacity: 0.5;
                    font-family: PingFangSC-Regular;
                    font-size: 42px;
                    color: #1F1F1F;
                    line-height: 42px;
                    font-weight: 400;
                }
            }
            .downloadShopCloseIcon {
                width: 36px;
                height: 36px;
            }
        }
        .download-info-center {
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin-bottom: 42px;
            .download-info-left {
                display: flex;
                align-items: center;
                width: 100%;
                .game-icon {
                    width: 230px;
                    height: 230px;
                    border-radius: 36px;
                    margin-right: 30px;
                }
                .game-info {
                    .game-name {
                        font-family: PingFangSC-Medium;
                        font-size: 48px;
                        color: #1F1F1F;
                        line-height: 48px;
                        font-weight: 500;
                        margin-bottom: 30px;
                    }
                    .game-info-download {
                        display: flex;
                        align-items: center;
                        font-family: PingFangSC-Regular;
                        font-size: 39px;
                        color: #1F1F1F;
                        line-height: 39px;
                        font-weight: 400;
                        .game-size {
                            opacity: 0.5;
                        }
                        .split-line {
                            width: 3px;
                            height: 27px;
                            opacity: 0.36;
                            background: #1F1F1F;
                            border-radius: 2px;
                            margin: 0 12px;
                        }
                        .game-download-num {
                            opacity: 0.5
                        }
                    }
                }
            }
            .download-btn {
                width: 192px;
                height: 93px;
                border-radius: 47px;
                text-align: center;
            }
        }
        .download-info-game-desc {
            opacity: 0.5;
            font-family: PingFangSC-Regular;
            font-size: 39px;
            color: #1F1F1F;
            line-height: 55px;
            font-weight: 400;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }
    .tieba-content {
        padding: 0 51px;
        box-sizing: border-box;
        .tieba-title {
            font-family: PingFangSC-Medium;
            font-size: 48px;
            color: #1F1F1F;
            line-height: 48px;
            font-weight: 500;
            margin-bottom: 42px;
        }
        .tieba-container {
            width: 1140px;
            height: 608px;
            background-image: linear-gradient(0deg, rgba(245,246,247,0.00) 0%, #F5F6F7 94%);
            border-radius: 36px 36px 0px 0px;
            .tieba-btn {
                width: 1056px;
                height: 132px;
                background: rgba(51,136,255,0.09);
                border-radius: 66px;
                margin-left: 42px;
                .tieba-btn-text {
                    font-family: PingFangSC-Regular;
                    font-size: 54px;
                    color: #3388FF;
                    text-align: center;
                    line-height: 132px;
                    font-weight: 400;
                }
            }
        }
    }
}
</style>